<app-header [title]="title()">
  @if (collectionSelected()) {
    <vault-collection-breadcrumbs
      slot="breadcrumbs"
      [scope]="parsedVaultScope()"
    ></vault-collection-breadcrumbs>
  }
</app-header>

<vault-organization-user-notifications></vault-organization-user-notifications>
<app-vault-banners [organizations]="organizations()"></app-vault-banners>

<app-vault-onboarding [ciphers]="activeCiphers()"></app-vault-onboarding>

<vault-shared-folder-card-grid
  [collections]="scopedCollections()"
  [scope]="vaultScope()"
></vault-shared-folder-card-grid>

<vault-items-table
  [ciphers]="ciphers()"
  [loading]="loading()"
  [rowActions]="rowActions()"
  [folders]="folders()"
  [collections]="scopedCollections()"
  [organizations]="scopedOrganizations()"
  [scopedOrganizationId]="scopedOrganizationId()"
  [defaultCollectionId]="defaultCollectionId()"
  [orgRequiresDataOwnership]="orgRequiresDataOwnership()"
  [itemAction]="itemAction"
  [copyPresentation]="copyPresentation()"
  [scope]="vaultScope()"
  [organizationName]="emptyVaultOrganizationName()"
  [hasMultipleVaults]="hasMultipleVaults()"
  [sharedFolderName]="emptySharedFolderName()"
>
  @if (showItemCreation()) {
    <vault-new-cipher-menu
      slot="empty-add-item"
      [canCreateCipher]="true"
      [canCreateSshKey]="true"
      [canCreateFolder]="false"
      [canCreateCollection]="false"
      (cipherAdded)="addCipher($event)"
      (onAddItemDialog)="openAddItemDialog()"
      id="vault-next_empty-new-cipher-menu"
    />
  }

  <div slot="toolbar" class="tw-flex tw-items-center tw-gap-3">
    @if (showItemCreation()) {
      <button
        id="vault-next_button_import"
        type="button"
        bitButton
        startIcon="bwi-download"
        buttonType="secondary"
        (click)="openImportDialog()"
      >
        {{ "importNoun" | i18n }}
      </button>
      <vault-new-cipher-menu
        [canCreateCipher]="true"
        [canCreateSshKey]="true"
        (cipherAdded)="addCipher($event)"
        (onAddItemDialog)="openAddItemDialog()"
      />
    }
  </div>
</vault-items-table>
